import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Router, RoutesRecognized, ActivatedRoute, Params } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { AgentDashboardComponent } from '../agent-dashboard/agent-dashboard.component';
import { environment } from '../../../environments/environment';
import { SharedVals } from '../../../shared/SharedVals';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-nav-tab',
  templateUrl: './nav-tab.component.html',
  styleUrls: ['./nav-tab.component.css']
})

export class NavTabComponent implements OnInit, AfterViewInit, OnDestroy {
  navTabs = environment.allTabs;
  clientNavTab = environment.clientTabs;
  activeTab;
  routerLink;
  showTabComponent: boolean = false;
  roleValue: any;
  hideFlag: boolean = false;
  subscription: ISubscription;

  constructor(public router: Router,
              public activatedRoute: ActivatedRoute,
              public sharedVals: SharedVals) {
  }

  ngOnInit() {
    this.subscription = this.sharedVals.roleValData.subscribe(data => {
      if (data == 8)
        this.hideFlag = true;
    }, err => {
        
        this.navTabs = [];
        this.hideFlag = true;
    });

    /*this.roleValue = localStorage.getItem("RoleVal");
    if (this.roleValue == 8) {
      this.hideFlag = true;
    }
    if (this.roleValue == 32) {
      this.navTabs = environment.vendorTabs;
    }*/
    if (this.activatedRoute.snapshot.params["docType"] !== undefined && this.activatedRoute.snapshot.params["docType"] !== '') {
      if (this.activatedRoute.snapshot.params["docType"] === 'DUEDILIGENCE')
        this.activeTab = 'Due Diligence';
      else if (this.activatedRoute.snapshot.params["docType"] === 'Dashboard')
        this.activeTab = 'Dashboard';
      else if (this.activatedRoute.snapshot.params["docType"] === 'LOCATION')
        this.activeTab = 'Location';
      else if (this.activatedRoute.snapshot.params["docType"] === 'LICENSE')
        this.activeTab = 'License';
      else if (this.activatedRoute.snapshot.params["docType"] === 'AGENTEMPLOYEE')
        this.activeTab = 'Employees';
      else if (this.activatedRoute.snapshot.params["docType"] === 'STATEREQUIREMENTS')
        this.activeTab = 'State Requirements';
      else if (this.activatedRoute.snapshot.params["docType"] === 'INSURANCE')
        this.activeTab = 'Insurance';
      else if (this.activatedRoute.snapshot.params["docType"] === 'SUMMARY')
        this.activeTab = 'Summary';
      else if (this.activatedRoute.snapshot.params["docType"] === 'COMPLAINTS')
        this.activeTab = 'Complaints';
      else if (this.activatedRoute.snapshot.params["docType"] === 'CHANGELOG') {
        this.activeTab = 'Change Log';
      }
    }
  }

  selectedTab(tab) {
    if (tab === 'Dashboard')
      this.router.navigate(['agent/dashboard', localStorage.getItem('AgentId'), 'Dashboard']);
    else if (tab === 'Summary')
      this.router.navigate(['agent/summary', localStorage.getItem('AgentId'), 'SUMMARY']);
    else if (tab === 'Location')
      this.router.navigate(['agent/location', localStorage.getItem('AgentId'), 'LOCATION']);
    else if (tab === 'Due Diligence')
      this.router.navigate(['agent/duediligence', localStorage.getItem('AgentId'), 'DUEDILIGENCE']);
    else if (tab === 'Insurance')
      this.router.navigate(['agent/insurance', localStorage.getItem('AgentId'), 'INSURANCE']);
    else if (tab === 'License')
      this.router.navigate(['agent/license', localStorage.getItem('AgentId'), 'LICENSE']);
    else if (tab === 'Employees')
      this.router.navigate(['agent/agentemployee', localStorage.getItem('AgentId'), 'AGENTEMPLOYEE']);
    else if (tab === 'State Requirements')
      this.router.navigate(['agent/staterequirements', localStorage.getItem('AgentId'), 'STATEREQUIREMENTS']);
    else if (tab === 'Complaints')
      this.router.navigate(['agent/complaints', localStorage.getItem('AgentId'), 'COMPLAINTS']);
    else if (tab === 'Change Log')
      this.router.navigate(['agent/changelog', localStorage.getItem('AgentId'), 'CHANGELOG']);
  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/nav-tab/nav-tab.component.ts